
export const useUtmTracking = () => {
  const getUTMParameters = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams: Record<string, string> = {};
    
    // Collect all UTM parameters
    const utmSourceValue = urlParams.get('utm_source');
    if (utmSourceValue) utmParams.utm_source = utmSourceValue;
    
    const utmMediumValue = urlParams.get('utm_medium');
    if (utmMediumValue) utmParams.utm_medium = utmMediumValue;
    
    const utmCampaignValue = urlParams.get('utm_campaign');
    if (utmCampaignValue) utmParams.utm_campaign = utmCampaignValue;
    
    const utmTermValue = urlParams.get('utm_term');
    if (utmTermValue) utmParams.utm_term = utmTermValue;
    
    const utmContentValue = urlParams.get('utm_content');
    if (utmContentValue) utmParams.utm_content = utmContentValue;

    // Also collect referrer if available
    if (document.referrer) {
      utmParams.referrer = document.referrer;
    }
    
    return utmParams;
  };

  return {
    getUTMParameters
  };
};
